import React,{useState} from 'react';

const InputArea = ({addItem}) => {
    const [inputText, setInputText] = useState("")
    console.log(inputText);

    const add =()=>{
      addItem(inputText);
      setInputText(" ");
    }

  return (
    <div className="input_Field">
        <input value={inputText} type="text" placeholder='ADD YOUR WORK'
         onChange={(event)=>setInputText(event.target.value)}/>

        <button onClick={add}>ADD</button>
    </div>
  );
};

export default InputArea;